import React from "react";

function Side() {
  return (
    <div className="flex flex-col md:flex-row items-center gap-2">
      <div className="w-8 h-8 bg-gray-200 rounded-full" />
      <div className="h-4 w-20 bg-gray-200 rounded" />
    </div>
  );
}

export default function PredictionSkeleton({ rows = 5 }) {
  return (
    <div className="animate-pulse space-y-3" aria-hidden>
      {Array.from({ length: rows }).map((_, idx) => (
        <div key={idx} className="bg-white rounded-xl border border-line shadow-sm px-3 py-3 md:px-4">
          <div className="flex justify-between mb-3">
            <div className="h-3 w-24 bg-gray-200 rounded" />
            <div className="h-5 w-16 bg-gray-100 rounded-full" />
          </div>
          <div className="grid grid-cols-[1fr_auto_1fr] items-center gap-3">
            <Side />
            <div className="h-12 w-28 bg-gray-100 rounded-lg" />
            <Side />
          </div>
        </div>
      ))}
    </div>
  );
}
